
export const checkCurrencyType = (itemCurrency: string) => {
  const globalStore = useGlobalStore();
  const { currencies } = storeToRefs(globalStore);
  
  const activeCurrency = currencies.value.find((currency) => currency.code === itemCurrency);
  return activeCurrency?.type || '';
};
